<template>
    <div class="qr-code">
        <div class="qr-code__btn" @click="toggleDialog">
            <span class="qr-code__btn-text">Личный QR-код</span>
            <div class="qr-code__btn-icon-container">
                <img class="qr-code__btn-icon" src="~@/assets/images/qr-code/qr-code-icon.svg" alt="Личный QR-код" />
            </div>
        </div>

        <Dialog
            :is-popup.sync="showDialog"
            :scrollable="false"
            :overlayOffset="false"
            :padding="false"
            @close="toggleDialog"
        >
            <QrModal :logo="logo.url || logo" />
        </Dialog>
    </div>
</template>

<script>
import Dialog from '@/components/UI/Dialog';
import QrModal from '@/components/UI/qr-code/QrModal.vue';

export default {
    name: 'QrCode',
    components: {
        Dialog,
        QrModal,
    },
    props: {
        logo: {
            type: String,
            required: false,
            default: '',
        },
    },
    data: () => ({
        showDialog: false,
    }),

    methods: {
        toggleDialog() {
            this.showDialog = !this.showDialog;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.qr-code {
    @include on-mobile {
        :deep(.dialog-wrapper) {
            background: none;
        }

        :deep(.dialog) {
            height: 100%;
            max-height: 100%;
            margin-top: mrem(16);
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
    }

    &__btn {
        background-color: #f6fafd;
        border-radius: mrem(10);
        margin: mrem(10) 0;
        padding: 0 mrem(10);
        width: mrem(184);
        height: mrem(44);
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include on-desktop {
            margin: rem(10) 0;
            width: rem(184);
            height: rem(44);
            padding: 0 rem(10);
            border-radius: rem(10);
        }
    }

    &__btn-text {
        font-weight: 500;
        font-size: mrem(14);
        color: #000;

        @include on-desktop {
            font-size: rem(14);
        }
    }

    &__btn-icon-container {
        background-color: #ebe8f9;
        width: mrem(36);
        height: mrem(36);
        border-radius: mrem(10);
        display: flex;
        align-items: center;
        justify-content: center;

        @include on-desktop {
            width: rem(36);
            height: rem(36);
            border-radius: rem(10);
        }
    }

    &__btn-icon {
        width: mrem(24);
        height: mrem(24);

        @include on-desktop {
            width: rem(24);
            height: rem(24);
        }
    }
}
</style>
